/**
 * Safely parses a string, extracting a key's value if it's a JSON object,
 * or returning the string itself. Handles falsy values.
 *
 * @param content The string to parse.
 * @param key Optional. The key to extract if `content` is a JSON object.
 * @returns The extracted string value, the original string, or `undefined`.
 */
export function safeParseString(
  content: string,
  key?: string,
): string | undefined {
  try {
    // If a key is provided, attempt to parse the content as JSON.
    // Otherwise, treat content as a direct string.
    if (key) {
      const data = JSON.parse(content);
      // If data is an object and contains the key, return its string value.
      if (typeof data === 'object' && data !== null && key in data) {
        const value = data[key];
        return value != null ? String(value) : undefined;
      }
    }
    return content != null ? String(content) : undefined;
  } catch {
    return content != null ? String(content) : undefined;
  }
}
